import { useBlobUrl } from '@/entities/shared/attachment/use-blob-url';
import { CategoryIcon } from '@/entities/shared/category/category-icon';
import { coverOf } from '../helpers/cover-of';
import type { Item } from '../schemas/item';

type ItemCoverProps = {
  readonly item: Item;
};

/** The item's photo when it has one on this device, otherwise its category icon. */
export function ItemCover({ item }: ItemCoverProps) {
  const url = useBlobUrl(coverOf(item)?.sha256);
  if (!url) return <CategoryIcon category={item.category} />;
  return <img src={url} alt="" className="size-12 shrink-0 rounded-lg border bg-white object-contain" />;
}
